import { createAction } from 'redux-act';

export const setRootPath = createAction('set rootPath');



// WEBPACK FOOTER //
// ./src/actions/global.js